import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiSimulatorExamnTypes extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}